import {
  BooleanInput,
  Edit,
  ReferenceArrayInput,
  SelectArrayInput,
  SimpleForm,
  TextInput,
  TopToolbar,
} from "react-admin";
import { makeStyles } from "@material-ui/styles";
import BackButton from "../../components/backButton";

const useStyles = makeStyles({
  actions: { justifyContent: "space-between" },
});

function RoleEdit(props) {
  const classes = useStyles();
  const Actions = () => {
    return (
      <TopToolbar className={classes.actions}>
        <BackButton />
      </TopToolbar>
    );
  };
  return (
    <Edit {...props} actions={<Actions />}>
      <SimpleForm>
        <TextInput source="name" label="name" />
        <BooleanInput source="isAdmin" label="isAdmin" />
        <ReferenceArrayInput source="permissions" reference="Permission" label="permissions" fullWidth>
          <SelectArrayInput optionText="name" />
        </ReferenceArrayInput>
      </SimpleForm>
    </Edit>
  );
}

export default RoleEdit;
